import { render, staticRenderFns } from "./promote.vue?vue&type=template&id=269bddba&scoped=true"
import script from "./promote.vue?vue&type=script&lang=js"
export * from "./promote.vue?vue&type=script&lang=js"
import style0 from "./promote.vue?vue&type=style&index=0&id=269bddba&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "269bddba",
  null
  
)

export default component.exports